import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { SKELETON_CLASSNAME } from '../base/constants';
import { IState } from '../store/state';
import './Highscores.scss';
import HighscoresFooter from './components/HighscoresFooter';
import HighscoresView from './components/HighscoresView';
import * as Selectors from './selectors';

export interface IHighscoresProps {
  loading: boolean;
}

export const HighscoresContainer: React.FC<IHighscoresProps> = ({ loading }) => {
  const { t } = useTranslation();

  const skeletonClass = loading ? SKELETON_CLASSNAME : '';
  // calculate current month
  const today = new Date();
  const currentMonth = today.getMonth();
  const monthName = t(`Month.${currentMonth}`);
  const title = t('Highscore.Title', { monthName });
  return (
    <div className={`highscores ${skeletonClass}`}>
      <h5>{title}</h5>
      <HighscoresView />
      <HighscoresFooter />
    </div>
  );
};

export const mapStateToProps = (state: IState) => {
  const loading = Selectors.isLoading(state);
  return {
    loading,
  };
};

const Highscores = connect(mapStateToProps)(HighscoresContainer);
export default Highscores;
